import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";

import { formatNumber } from "components/utils/functions";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip
);

const getOptions = (datasets) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    tooltip: {
      callbacks: {
        label: (context) => {
          let label = context.dataset.label || "";
          if (label) {
            label += ": ";
          }
          if (context.parsed.y !== null && context.dataset.onOff)
            label += context.parsed.y === 1 ? "On" : "Off";
          else if (context.parsed.y !== null)
            label += `${formatNumber(context.parsed.y, 2)} ${
              context.dataset.unit ?? ""
            }`;
          return label;
        },
      },
    },
  },
  scales: {
    y: {
      title: {
        display: !!datasets[0].unit,
        text: datasets[0].unit,
      },
      ...(datasets[0].onOff && {
        ticks: {
          callback: function (value) {
            return value === 1 ? "On" : "Off";
          },
          stepSize: 1,
        },
      }),
      min: 0
    },
    x: {
      title: {
        display: !!datasets[0].xAxisLabel,
        text: datasets[0].xAxisLabel,
      },
    },
  },
});

const LineChart = ({ labels, datasets }) => {
  return (
    <Line
      options={{
        ...getOptions(datasets),
      }}
      data={{ labels, datasets }}
    />
  );
};

export default LineChart;
